import Apis from 'apis';
import { objToQueryString } from 'utils/helpers';

export const api = Apis({});

interface QueryProps {
  limit?: number | string;
  offset?: number | string;
  search?: string;
}

export default {
  newPartner: () => '/partner/',
  getTheme: (partnerUuid: string) => `partner/${partnerUuid}/user-theme/`,
  saveTheme: (partnerUuid: string) => `partner/${partnerUuid}/user-theme/`,
  editTheme: (partnerUuid: string) => `partner/${partnerUuid}/user-theme/`,
  deleteTheme: (partnerUuid: string) =>
    `partner/${partnerUuid}/user-theme/remove/`,
  publishTheme: (partnerUuid: string) =>
    `partner/${partnerUuid}/user-theme/publish/`,
  removeImage: (partnerUuid: string) =>
    `partner/${partnerUuid}/user-theme/remove-image/`,
  getPartner: (id: string) => `/partner/${id}/`,
  editPartner: (id: string) => `/partner/${id}/`,
  deletePartner: (id: string) => `/partner/${id}/`,
  getAllPartners: (query: QueryProps) => `/partner/?${objToQueryString(query)}`,
  getAllPartnersOperator: (query: QueryProps) =>
    `/partner/summary/?${objToQueryString(query)}`,
  LDAPTest: (partnerUuid: string) => `/partner/${partnerUuid}/ldap/test/`,
  getAllPartnerServers: (
    partnerUuid: string,
    serverType: string,
    query: QueryProps
  ) =>
    `partner/${partnerUuid}/server/?server_type=${serverType}&${objToQueryString(
      query
    )}`,

  startPartnerServers: (partnerUuid: string) =>
    `partner/${partnerUuid}/server/start/`,
  stopPartnerServers: (partnerUuid: string) =>
    `partner/${partnerUuid}/server/stop/`,
  publishPartnerServers: (partnerUuid: string) =>
    `partner/${partnerUuid}/server/publish-new-image/`,
  clonePartner: (partnerUuid: string) => `partner/${partnerUuid}/clone/`,
  changeAdPassword: (partnerUuid: string) =>
    `partner/${partnerUuid}/change-ad-password/`,
  getLDAPTypeReport: (query: QueryProps) =>
    `/partner/report/ldap-type/?${objToQueryString(query)}`,
  getSSOReport: (query: QueryProps) =>
    `/partner/report/sso/?${objToQueryString(query)}`,
  getNewFrontReport: (query: QueryProps) =>
    `/partner/report/new-front/?${objToQueryString(query)}`,
  getPartnerProviderTypeReport: (query: QueryProps) =>
    `/partner/report/provider-type/?${objToQueryString(query)}`,
  exportPartnerSummary: (query: QueryProps) =>
    `/partner/summary/export/?${objToQueryString(query)}`,
  publishImagePartner: (partnerUuid: string) =>
    `/partner/${partnerUuid}/server/publish-image/`,
  blockServerPartnerActions: (partnerUuid: string) =>
    `/partner/${partnerUuid}/server/block-actions/`,
  unblockServerPartnerActions: (partnerUuid: string) =>
    `/partner/${partnerUuid}/server/unblock-actions/`,
  getInstancesByUsage: (partnerUuid: string, query: QueryProps) =>
    `/partner/${partnerUuid}/instances/?${objToQueryString(query)}`,
};
